// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__BHxwa","name":"Products_name__AsKKJ","subcontent":"Products_subcontent__hi-Mn"};